<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="meeting_date" slot-scope="{ item }">
            {{ item.meeting_date | datetime }}
        </template>

        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>

        <template slot="meeting_description" slot-scope="{ item }">
            <a href="#" @click.prevent="seeDetails(item)">
                {{ item.meeting_description | elipsis(100) }}
            </a>
        </template>

        <template slot="actions" slot-scope="data">
            <b-button size="sm" variant="primary" @click="seeDetails(data.item)"><i class="fa fa-search-plus"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields';
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: fields
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        seeDetails(data){
            this.$emit('see-details-report', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    }
}
</script>
<style scoped>
    .details {
        cursor: pointer;
    }
</style>